export function getUniqueId() {
  return generateId() + '-' + generateId() + '-' + generateId();
}

const generateId = function () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
